<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">User Feedback Report</h4>
    </div>
    <div class="col-sm-3"></div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="row p-t-20">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label class="control-label">From Date</label>
                            <input type="date" id="dateTime" name="dateTime" class="form-control form-control-sm" [(ngModel)]="ufdForm.fromDate"  (change)="FeedbackDetailReport()" >
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label class="control-label">To Date</label>
                            <input type="date" id="toDate" name="toDate" class="form-control form-control-sm"  [(ngModel)]="ufdForm.toDate"  (change)="FeedbackDetailReport()"  >

                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="device_id">Toilet</label>
                            <ng-select [items]="deviceDataArr" bindLabel="deviceLabel" bindValue="id"
                                placeholder="Select Toilet" appendTo="body" name="device_id"
                                (change)="FeedbackDetailReport()" [(ngModel)]="ufdForm.device_id">
                            </ng-select>
                        </div>
                    </div>
                    <!-- <div style="margin-top: 30px;" class="col-md-2">
                        <button type="button" class="btn btn-outline-info" (click)="ShowReport()">Submit</button>
                    </div> -->
                </div>

<!-- 
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="row card-body">
                                <div class="col-md-5">
                                    <h3 class="card-title"><i class="fa fa-users p-2" style="font-size: 20px;"></i><strong>Feedback Report</strong> </h3>
                                </div>
                                <div class="col-md-7">
                                    <div class="form-group">
                                        <label for="device_id">Device</label>
                
                                        <ng-select [items]="deviceDataArr" bindLabel="deviceLabel" bindValue="id"
                                            placeholder="Select Device" appendTo="body" name="device_id" id="device_id"
                                            (change)="getHourlyDataDevicewise($event.id)" [(ngModel)]="dashboardForm.device_id">
                                        </ng-select>
                                       
                                    </div>
                                </div>
                                <div class="row col-lg-12">
                                    <canvas baseChart [data]="deviceBarChartData" [labels]="deviceBarChartLabels"
                                        [options]="deviceBarChartOptions" [colors]="deviceBarChartColors"
                                        [legend]="deviceBarChartLegend" [chartType]="deviceBarChartType"
                                        (chartClick)="chartClickedDevicewise($event)">
                                    </canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->


                <div class="row mb-2">
                    <div class="col-md-12">
                        <label class="mr-3">
                        <input type="radio"
                                name="feedbackFilter"
                                value="ALL"
                                [(ngModel)]="selectedFeedback"
                                (change)="applyFeedbackFilter()"> All
                        </label>

                        <label class="mr-3">
                        <input type="radio"
                                name="feedbackFilter"
                                value="Clean"
                                [(ngModel)]="selectedFeedback"
                                (change)="applyFeedbackFilter()"> Clean
                        </label>

                        <label class="mr-3">
                        <input type="radio"
                                name="feedbackFilter"
                                value="Ok"
                                [(ngModel)]="selectedFeedback"
                                (change)="applyFeedbackFilter()"> Ok
                        </label>

                        <label class="mr-3">
                        <input type="radio"
                                name="feedbackFilter"
                                value="Dirty"
                                [(ngModel)]="selectedFeedback"
                                (change)="applyFeedbackFilter()"> Dirty
                        </label>
                    </div>
                </div>

                <div class="table-responsive">
                    <table  id="feedbackTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                        class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Zone</th>
                                <th>Ward</th>
                                <th>Toilet ID</th>
                                <th>MoHUA (GTL ID)</th>
                                <th>Toilet Name</th>
                                <th>Device ID</th>
                                <th style="white-space: normal;">Address</th>
                                <th>Feedback</th>
                                <!-- <th>HO</th>
                                <th>CSI</th> -->
                                <!-- <th>Daroga</th> -->
                                <th>Updated</th>
                                <th>Contact</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of rowData; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{data.zone_name}}</td>
                                <td>{{data.ward_name}}</td>
                                <td style="white-space: normal;">{{data.toilet_no}}</td>
                                <td style="white-space: normal;">{{data.google_toilet_id}}</td>
                                <td style="white-space: normal;">{{data.toilet_name}}</td>
                                <td>{{data.device_id}}</td>
                                <td style="white-space: normal;">{{data.address}}</td>
                                <td>{{data.feedback}}</td>
                                <!-- <td style="white-space: normal;">{{data.ho_name}}</td>
                                <td style="white-space: normal;">{{data.csi_name}}</td> -->
                                <!-- <td style="white-space: normal;">{{data.daroga_name}}</td> -->
                                <td>{{data.log_date_time}}</td>
                                <td><button class="btn btn-info " data-toggle="modal" data-target="#contactModal">
                                        <span id="totalZone" style="cursor: pointer;"
                                            (click)="ShowContactDetail(data.device_id)">
                                            <i class="fa fa-phone" aria-hidden="true"></i>
                                        </span>
                                    </button>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="contactModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Contact Information</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"  (click)="closeModal1()" >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" >
                <table class="table table-bordered table-striped" style="font-size:14px;">
                    
                    <tr>
                        <td class="text-center track_table_idle"><b>HO</b></td>
                        <td class="text-center track_table_idle" ><b>{{selectedDeviceData.ho_name}}</b></td>
                    </tr>
                    <tr>
                        <td class="text-center track_table_idle"><b>CSI</b></td>
                        <td class="text-center track_table_idle"><b>{{selectedDeviceData.csi_name }}</b></td>
                    </tr>
                    <tr>
                        <td class="text-center track_table_idle"><b>Daroga</b></td>
                        <td class="text-center track_table_idle"><b>{{selectedDeviceData.daroga_name}}</b></td>
                    </tr>

                </table>
            </div>

            <div class="modal-footer" *ngIf="roleId>=1">
                <button type="button" class="btn btn-secondary" (click)="closeModal()" data-dismiss="modal">Close</button>
            </div>
            <div class="modal-footer d-flex justify-content-between align-items-center" *ngIf="roleId==0">

                <!-- Left Side : Radio Buttons -->
                <div>
                    <label class="mr-3 mb-0">
                        <input type="radio"
                            name="smsType"
                            value="aqi"
                            [(ngModel)]="selectedSmsType">
                        AQI
                    </label>

                    <label class="mr-3 mb-0">
                        <input type="radio"
                            name="smsType"
                            value="water_level"
                            [(ngModel)]="selectedSmsType">
                        WATER LEVEL
                    </label>

                    <label class="mb-0">
                        <input type="radio"
                            name="smsType"
                            value="feedback"
                            [(ngModel)]="selectedSmsType">
                        FEEDBACK
                    </label>
                </div>

                <!-- Right Side : Buttons -->
                <div>
                    <button type="button"
                            class="btn btn-primary mr-2"
                            (click)="sendSmsNotification()">
                        SEND SMS
                    </button>

                    <button type="button"
                            class="btn btn-secondary"
                            (click)="closeModal()"
                            data-dismiss="modal">
                        CLOSE
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>